import { useReducer } from "react";
import api from '../../../../../../../../api/organizations';

const intialState = {
  posts: [],
  departments: [],
  persons: []
};

function reducer(state, action) {
  switch (action.type) {
    case "GET_FORM":
      return {
        ...state,
        departments: action.departments,
        posts: action.posts,
        persons: action.persons,
      };
    default:
      return {
        ...state
      };
  }
}

export default function useAddExistingForm() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);

  function getForm(orgId) {
    Promise.all([
      api.getPostsDict(),
      api.getOrganizationDepartments(orgId),
      api.getFormPersons()
    ]).then(([posts, departments, persons]) => {
      dispatch({
        type: "GET_FORM",
        posts: posts.data ? posts.data.data : [],
        departments: departments.data,
        persons: persons.data
      });
    });
  }

  return {
    dataSources,
    getForm,
  };
}
